import { GET_CLIENT_ALL_PROPERTY } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_CLIENT_ALL_PROPERTY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_ALL_PROPERTY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_CLIENT_ALL_PROPERTY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
